import React from 'react';
import ReactDOM from 'react-dom/client';


import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Ensures all Bootstrap JS, including ScrollSpy, is loaded,  Needed for accordion toggle
import 'bootstrap-icons/font/bootstrap-icons.css';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';

import { HelmetProvider } from "react-helmet-async"; // for managing meta tags dynamically


import './index.css';




//=======================================================================
// INSURANCE
// import AppRouts_v01 from './Insurance-Legacy/App_v01_LegacyInsurance_Routes';

// import AppRouts_v01 from './easy-contractor/App_v01_EasyContractor_Insurance_Routes';


 import AppRouts_v01 from './discount-painters-insurance/App_v01_DiscountPaintersInsurance_Routes';



// DUI Insurance
// OLD REV  import AppRouts_v01 from './DUIInsurance/App_v01_DUIInsurance_Routes';
// import AppRouts_v01 from './EasyDUI-Insurance/App_v01_EasyDUI_Insurance_Routes';


// RENTERS - DISCOUNT RENTERS INSURANCE.COM
// import AppRouts_v01 from './discount-renters-insurance/App_v01_DiscountRentersInsurance_Routes';

// EASY DUI
// import AppRouts_v01 from './EasyDUI-Insurance/App_v01_EasyDUI_Insurance_Routes';

// LONGEVITY
// import AppRouts_v01 from './LONGEVITY-HealthAdvisors/App_v01_LONGEVITY_Routes';

// EASY Welding
// import AppRouts_v01 from './Discount-Welding-2025/App_v01_Welding_Insurance_Routes';

// CUSTOM EDGE 
// import AppRouts_v01 from './Custom-Edge-Fabrication/App_v01_CustomEdge_Routing';

// VENDING 
// import AppRouts_v01 from './sundance-vending/App_v01_SundanceVending_Routes';

// MEMORY SCORE CARD
// import AppRouts_v01 from './ScoreCards/memoryScoreCard/App_v01_MemoryScoreCard_Routes';

// SMART MONEY.CREDIT
// import AppRouts_v01 from './ScoreCards/SmartMoneyCredit/App_v01_SmartMoney_Routes';

// TAX DEEP DIVE 
// import AppRouts_v01 from './TaxDeepDive/App_v01_TaxDeepDive_Routes';

// DIVORCE READY 
// import AppRouts_v01 from './ScoreCards/DivorceReady/App_v01_DivorceReadyScoreCard_Routes';


// HOSTING SCORE CARD

// TRASH OUT
// import AppRouts_v01 from './easy-trash-out/App_v01_Trashout_Routes';

// CLOUD TRAINING - CLOUD LEADERSHIP TEAM 
// import  AppRouts_v01  from "./certified-cloud-training/App_v01_CertifiedCloudTraining";

// import AppRouts_v01 from './hot-limo/App_v01_HotLimo';

//TIMBERLINE CLOUD
// import AppRouts_v01 from "./timberline-cloud/App_v01_TimberLineCloud_Routes";

//=======================================================================







///"Best in class" service means a service that consistently surpasses customer expectations, delivers rapid and effective solutions, and creates a positive customer experience. It's about being the top performer within a category, outshining competitors in key areas like quality, customer satisfaction, and efficiency. Essentially, it's service that is not just good, but exceptional and consistently so. 
// https://www.superoffice.com/blog/best-in-class-customer-service/



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
        <AppRouts_v01 />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();



